import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Spin, Card, Button, Input, Tabs, Table, Modal, Space, Tag, Drawer } from "antd";
import POSLogo from "../../../../../assets/images/NewLogoCW.svg";
import LockIcon from "../../../../../assets/images/lock-icon.svg";
import userIcon from "../../../../../assets/images/userId.svg";
import Online from "../../../../../assets/images/green.svg";
import Offline from "../../../../../assets/images/red.svg";
import BackIcon from "../../../../../assets/images/backIcon.svg";
import SearchIcon from "../../../../../assets/images/searchIcon.svg";
import db from "../../../../../database";
import usePOSConfigStore from "../../../../../stores/usePOSConfigStore";
import {
  PrinterOutlined,
  UserOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  CreditCardOutlined,
  CalendarOutlined,
  CheckCircleTwoTone,
  ExclamationCircleTwoTone,
  CloseOutlined,
  LoadingOutlined,
  CloseSquareFilled,
  RightOutlined,
  DownOutlined,
  EditOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  AppstoreOutlined,
  CodeSandboxOutlined,
  RedoOutlined,
  WarningOutlined,
  CarOutlined,
  GiftOutlined,
  ReloadOutlined,
  ArrowsAltOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useHistory } from "react-router-dom";
import sortBy from "lodash/sortBy";
import Scrollbars from "react-custom-scrollbars";
import useAuthStore from "../../../../../stores/useAuthStore";
import { formatCurrencyAmount } from "../../../../../utils/tillHelpers";
import useWindowDimensions from "../../../../../hooks/useWindowDimensions";
import "../../restaurantStyle.css";
import { CANCEL_TYPE, PREORDER_TABS, classifyPreorders, filterPreordersByTab, isCancelledPreorder } from "../../../../../utils/preorderCancelled";
import AdvanceOrderCancelModal from "../../../../PreOrder/AdvanceOrderCancelModal";
import { CANCEL_MESSAGES } from "../../../../../utils/advanceOrderCancel";

const RestaurantPreorder = (props) => {
  const {
    loading,
    setLoading,
    searchOrderHistory,
    orderHistoryDetails,
    setOrderHistoryDetails,
    getSalesHistoryData,
    tillData,
    selectedDocumentType,
    setSelectedDocumentType,
    selectedSaleType,
    setSelectedSaleType,
    selectedSaleTypeData,
    setSelectedSaleTypeData,
    getFilteredPaymentMethods,
    setShowPayments,
    retrieveLayaway,
    selectLayAwayOrder,
    setKeyValue,
    dateRange,
    setDateRange,
  } = props;
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  const history = useHistory();
  const { isMobile } = useWindowDimensions();
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  })}`;
  const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [activeTab, setActiveTab] = useState(PREORDER_TABS.ACTIVE);
  // BUG-2485: the details fetch does not carry docstatus, so remember whether the clicked
  // row is cancelled to keep the details panel view-only (no Retrieve).
  const [selectedIsCancelled, setSelectedIsCancelled] = useState(false);
  // TSK-5163: Cancel Order dialog for the order shown in the details panel.
  const [showCancelModal, setShowCancelModal] = useState(false);
  const visibleOrders = useMemo(() => filterPreordersByTab(orderHistoryDetails, activeTab), [orderHistoryDetails, activeTab]);

  const errorMessage = (modalTitle, modalContent) => {
    Modal.error({
      title: modalTitle,
      content: modalContent,
    });
  };
  function arraysAreEqual(arr1, arr2) {
    return JSON.stringify(arr1) === JSON.stringify(arr2);
  }

  useEffect(() => {
    // PreOrder is Take Away only — Dine In (and any other fulfilment type) advance/layaway
    // orders must never show up here. Order records only carry saleType.cwrSaletypeId, not
    // fulfilmentType itself, so resolve it against the synced posSaletypes master table
    // (same lookup pattern as OrderListComponent.js's findMatchingColor).
    const applyFilters = async () => {
      if (orderHistoryDetails.length === 0) return;

      const layawayOrders = orderHistoryDetails.filter((item) => {
        return posConfig?.advanceLayaway === "Y" ? item.layAway === "Y" : item.layAway === "Y" && item.paid === 0;
      });

      const saleTypes = await db.posSaletypes.toArray();
      const fulfilmentTypeById = new Map(saleTypes.map((st) => [st?.cwrSaletype?.cwrSaletypeId, st?.cwrSaletype?.fulfilmentType]));
      const takeAwayOrders = layawayOrders.filter((item) => fulfilmentTypeById.get(item?.saleType?.cwrSaletypeId) === "TA");

      // BUG-2485: both cancel types (docstatus "CAN" and the zero-valued cart-cancel
      // record) are tagged "Cancelled" and shown only in the Cancelled tab.
      const enrichedLayawayOrders = classifyPreorders(takeAwayOrders);

      if (!arraysAreEqual(enrichedLayawayOrders, orderHistoryDetails)) {
        setOrderHistoryDetails(enrichedLayawayOrders);
      }
    };
    applyFilters();
  }, [orderHistoryDetails]);

  //   useEffect(() => {
  //     const isOnline = navigator.onLine;

  //     if (isOnline) {
  //       let dateValue = [dayjs(new Date()), dayjs(new Date())];
  //       setLoadingDetails(true);
  //       searchOrderHistory("orderDateSearchKey", dateValue, 0, false, true);
  //       // setShowPreOrders(true);
  //       setLoadingDetails(false);
  //     } else {
  //       errorMessage("Sync Failed", "Please check your network connection and try again");
  //     }
  //   }, []);

  const fetchOrders = async () => {
    if (!navigator.onLine) {
      errorMessage("Sync Failed", "Please check your network connection and try again");
      return;
    }

    try {
      setLoadingDetails(true);

      const dateValue = [dayjs(), dayjs()];
      // Passing `true` (not an array) here made useOrderHistory fall through to its
      // default of mirroring the Order Date range onto Delivery Date, silently hiding
      // advance orders whose delivery date falls outside that window (BUG-1929).
      await searchOrderHistory("orderDateSearchKey", dateValue, 0, false, true, [null, null]);
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoadingDetails(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  // Shared between the desktop inline details panel and the mobile
  // right-side Drawer (added for mobile responsiveness — see the
  // isMobile Drawer below) so both render the exact same title/body
  // JSX instead of forking the markup in two places.
  const renderOrderDetailsTitle = () => (
    <Row justify="space-between" align="middle">
      <Col>
        <span style={{ fontSize: "14px", fontWeight: 600, color: "#0F0718" }}>Order Details</span>
      </Col>
      <Col>
        <Button icon={<PrinterOutlined />} style={{ height: "28px", width: "28px", borderRadius: "6px" }} />
      </Col>
    </Row>
  );

  const renderOrderDetailsBody = () => (
    <>
      <div style={{ height: "100%", flex: 1, overflowY: "auto", overflowX: "hidden" }}>
        <Space direction="vertical" size={12} style={{ width: "100%" }}>
          {/* Header */}
          <Row justify="space-between" align="middle">
            <Col>
              <div style={{ fontSize: "16px", fontWeight: 600, color: "#0F0718" }}>{selectedOrderDetails?.documentno}</div>
              <div style={{ fontSize: "10px", color: "#6b7280", color: "#0F0718" }}>{selectedOrderDetails?.orderTime}</div>
            </Col>

            <Col style={{ textAlign: "right" }}>
              <div style={{ fontSize: "14px", fontWeight: 600, color: "#0F0718" }}>{formatCurrencyAmount(tillData, selectedOrderDetails?.total)}</div>

              {/* <Tag color={selectedOrderDetails.status === "Success" ? "green" : "red"}>{selectedOrderDetails?.status}</Tag> */}
            </Col>
          </Row>

          {/* Customer Info */}
          <div>
            <div style={{ fontSize: "1em", fontWeight: 600, marginBottom: 4, color: "#0F0718" }}>Customer Information</div>

            <Space direction="vertical" size={4} style={{ fontSize: "12px" }}>
              <Row gutter={8}>
                <Col>
                  <UserOutlined />
                </Col>
                <Col style={{ color: "#0F0718" }}>{selectedOrderDetails?.customer?.name || "N/A"}</Col>
              </Row>
              {selectedOrderDetails?.customer?.mobileNo ? (
                <Row gutter={8}>
                  <Col>
                    <PhoneOutlined />
                  </Col>
                  <Col style={{ fontSize: "10px", color: "#6b7280" }}>{selectedOrderDetails?.customer?.mobileNo || ""}</Col>
                </Row>
              ) : null}

              {selectedOrderDetails?.customer?.mobileNo ? (
                <Row gutter={8}>
                  <Col>
                    <EnvironmentOutlined />
                  </Col>
                  <Col style={{ fontSize: "10px", color: "#6b7280" }}>{selectedOrderDetails?.customer?.mobileNo || ""}</Col>
                </Row>
              ) : null}
            </Space>
          </div>

          {/* Order Items */}
          <div>
            <div style={{ fontSize: "12px", fontWeight: 600, marginBottom: 4, fontSize: "1em", color: "#0F0718" }}>Order Items</div>

            <Space direction="vertical" size={4} style={{ width: "100%" }}>
              {selectedOrderDetails.items?.map((item, index) => (
                <Row key={index} justify="space-between">
                  <Col style={{ display: "flex", justifyContent: "center" }}>
                    <span style={{ fontWeight: 500, fontSize: "0.8em", color: "#0F0718" }}>{item.name}</span>
                    <span style={{ color: "#6b7280", marginLeft: 8, fontSize: "0.8em" }}>x{item.qty}</span>
                  </Col>

                  <Col style={{ display: "flex", justifyContent: "center", fontSize: "0.8em", color: "#0F0718" }}>{formatCurrencyAmount(tillData, item.nettotal)}</Col>
                </Row>
              ))}
            </Space>
          </div>

          {/* Summary */}
          <div style={{ borderTop: "1px solid #d1d5db", paddingTop: 8 }}>
            <Space direction="vertical" size={4} style={{ width: "100%" }}>
              <Row justify="space-between" style={{ fontSize: "0.9em" }}>
                <Col style={{ color: "#0F0718" }}>Subtotal</Col>
                <Col style={{ color: "#0F0718" }}>{formatCurrencyAmount(tillData, selectedOrderDetails?.subTotal)}</Col>
              </Row>

              <Row justify="space-between" style={{ fontSize: "0.9em" }}>
                <Col style={{ color: "#0F0718" }}>Tax</Col>
                <Col style={{ color: "#0F0718" }}>{formatCurrencyAmount(tillData, selectedOrderDetails?.tax)}</Col>
              </Row>

              {selectedOrderDetails.discount > 0 && (
                <Row justify="space-between" style={{ fontSize: "0.9em" }}>
                  <Col>Discount</Col>
                  <Col>-{formatCurrencyAmount(tillData, selectedOrderDetails.discount)}</Col>
                </Row>
              )}

              <Row
                justify="space-between"
                style={{
                  fontWeight: 600,
                  borderTop: "1px solid #d1d5db",
                  paddingTop: "1.2vh",
                  fontSize: "1em",
                  color: "#0F0718",
                }}
              >
                <Col>Total</Col>
                <Col>{formatCurrencyAmount(tillData, selectedOrderDetails.total)}</Col>
              </Row>
            </Space>
          </div>

          {/* Payment Info */}
          <div>
            <Space direction="vertical" size={4} style={{ width: "100%" }}>
              {selectedOrderDetails.paymentData?.map((payment, index) => (
                <Row key={index} style={{ color: "#0F0718" }} justify="space-between">
                  <Col>
                    <CreditCardOutlined /> {payment.name}
                  </Col>
                  <Col>{formatCurrencyAmount(tillData, payment.amount)}</Col>
                </Row>
              ))}
            </Space>
          </div>
        </Space>
      </div>
      {/* BUG-2485: cancelled pre-orders are view-only — no Retrieve. */}
      {!selectedIsCancelled && (
        <div
          style={{
            marginTop: "12px",
            paddingTop: "12px",
            borderTop: "1px solid #e5e7eb",
          }}
        >
          {/* TSK-5163: same Cancel Order as the retail Manage Pre-Order screen. */}
          <Button
            block
            danger
            style={{ height: "40px", borderRadius: "8px", fontWeight: 600, marginBottom: "8px" }}
            onClick={() => {
              if (typeof navigator !== "undefined" && navigator.onLine === false) {
                errorMessage("Cancel Order", CANCEL_MESSAGES.offline);
                return;
              }
              setShowCancelModal(true);
            }}
          >
            Cancel Order
          </Button>
          <Button
            block
            style={{
              height: "40px",
              borderRadius: "8px",
              fontWeight: 600,
              backgroundColor: "#2F3856",
              color: "white",
              marginBottom: "7vh",
            }}
            onClick={async () => {
              const detail = {
                ...selectedOrderDetails,
                docType: "Invoice",
                type: "Layaway",
                preOrder: "Y",
                layAway: "Y",
                isPreOrderPage: true,
                wasLayaway: true,
                isAdvance: "Y",
                finishLayaway: false,
                statusType: "layAway",
              };
              selectLayAwayOrder(detail, true);
              setSelectedDocumentType("Invoice");
              // setExpandedRowKeys([]);
              // setSearchhistoryInput("");
              const saleData = await db.posSaletypes.toArray();
              saleData.map((item) => {
                if (item.cwrSaletype.cwrSaletypeId === detail.saleType.cwrSaletypeId) {
                  setSelectedSaleTypeData(item);
                  usePOSConfigStore.getState().setSaleTypeData(item);
                  setSelectedSaleType(item?.cwrSaletype?.name);
                }
              });
              let paymentDetails = getFilteredPaymentMethods(detail?.saleType?.cwrSaletypeId || null);
              let payments =
                paymentDetails.length > 5
                  ? sortBy(paymentDetails, "sequenceNo").slice(
                      0,
                      tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === detail?.customer?.cwrCustomerId && paymentDetails.length === 5 ? 4 : 4
                    )
                  : paymentDetails;
              // setStartIndex(payments.length);
              setShowPayments(payments);
              localStorage.setItem("isRetrieve", "Y");
              setKeyValue("2");
              history.push("/pos");
            }}
          >
            Retrieve
          </Button>
        </div>
      )}
    </>
  );

  return (
    <Spin spinning={loadingDetails} indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#2F3856" }} />}>
      <div className="preorder-root" style={{ backgroundColor: colorVariable ? colorVariable : "#f3f4f9", height: "100vh", width: "100%", padding: "10px", overflow: "hidden" }}>
        <div
          className="preorder-header"
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: "8px 12px",
            marginBottom: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          }}
        >
          <Row className="preorder-header-row" align="middle" justify="space-between">
            <Col>
              <Row align="middle" gutter={8}>
                <Col>
                  <img
                    src={BackIcon}
                    style={{ height: "24px", cursor: "pointer" }}
                    onClick={() => {
                      history.push("/pos");
                    }}
                    alt="Back"
                  />
                </Col>
                <Col>
                  <img
                    src={POSLogo}
                    style={{ height: "32px", cursor: "pointer" }}
                    // onClick={onPosClick}
                    alt="POS Logo"
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Row className="preorder-header-right" align="middle" gutter={8}>
                <Col>
                  <span style={{ fontSize: "12px", color: "#6b7280" }}>{formattedDateTime}</span>
                </Col>
                <Col>
                  <img src={LockIcon} style={{ height: "20px", cursor: "pointer" }} alt="Lock" />
                </Col>
                <Col>
                  <div
                    style={{
                      border: "1px solid #4b5563",
                      borderRadius: "50%",
                      padding: "4px",
                    }}
                  >
                    <img src={userIcon} style={{ height: "20px" }} alt="User" />
                  </div>
                </Col>
                <Col>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontSize: "12px", fontWeight: 500 }}>{useAuthStore.getState().userData?.user}</span>
                    <span style={{ fontSize: "10px", color: "#6b7280" }}>Till ID : {useAuthStore.getState().tillValue?.name}</span>
                  </div>
                </Col>
                <Col>
                  <img src={navigator.onLine ? Online : Offline} style={{ height: "20px" }} alt={navigator.onLine ? "Online" : "Offline"} />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <Row className="preorder-content-row" gutter={16} style={{ height: "calc(100vh - 80px)" }}>
          <Col className="preorder-list-col" span={16} style={{ borderRadius: "5px", height: "100%" }}>
            <Card
              style={{ height: "100%", borderRadius: "10px", padding: "5px" }}
              styles={{
                body: {
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  padding: "16px",
                },
              }}
            >
              <Row gutter={8} align="middle" justify="space-between" style={{ marginBottom: 10 }}>
                <Col flex="auto">
                  <Input
                    placeholder="Search by Order No..."
                    prefix={<img src={SearchIcon} style={{ height: 16 }} alt="Search" />}
                    onPressEnter={async (e) => {
                      if (e.target.value !== "") {
                        try {
                          setLoadingDetails(true);
                          setSelectedOrderDetails(null);
                          await searchOrderHistory("customer", e.target.value, 0, dateRange?.length > 0 ? true : false);
                        } catch (err) {
                          setSelectedOrderDetails(null);
                          setLoadingDetails(false);
                          console.error("Search failed:", err);
                        } finally {
                          setSelectedOrderDetails(null);
                          setLoadingDetails(false);
                        }
                      } else {
                        try {
                          setLoadingDetails(true);
                          setSelectedOrderDetails(null);
                          await fetchOrders();
                        } catch (err) {
                          setSelectedOrderDetails(null);
                          setLoadingDetails(false);
                          console.error("Search failed:", err);
                        } finally {
                          setSelectedOrderDetails(null);
                          setLoadingDetails(false);
                        }
                      }
                    }}
                    style={{ height: 32, fontSize: 12, borderRadius: 6, width: "97%" }}
                  />
                </Col>
              </Row>

              <Tabs
                activeKey={activeTab}
                onChange={(key) => {
                  setActiveTab(key);
                  setSelectedOrderDetails(null);
                }}
                items={[
                  { key: PREORDER_TABS.ACTIVE, label: PREORDER_TABS.ACTIVE },
                  { key: PREORDER_TABS.CANCELLED, label: PREORDER_TABS.CANCELLED },
                ]}
              />
              <Table
                className="sm-restaurant-preorder-table"
                scroll={{ x: "max-content" }}
                columns={[
                  { title: "Document Number", dataIndex: "documentno", key: "documentno" },
                  { title: "Date", dataIndex: "orderDate", key: "orderDate" },
                  {
                    title: "Customer",
                    key: "customerName",
                    render: (_, record) => record?.customer?.name || "N/",
                  },
                  {
                    title: "Total Amount",
                    dataIndex: "total",
                    key: "total",
                    render: (total, record) => (record.cancelType === CANCEL_TYPE.CART ? "Cart cancelled" : total),
                  },
                  {
                    title: "Type",
                    dataIndex: "type",
                    key: "type",
                    width: "20%",
                    filters: [
                      {
                        text: "Layaway",
                        value: "Layaway",
                      },
                      {
                        text: "Return",
                        value: "Return",
                      },
                      {
                        text: "Receipt",
                        value: "Receipt",
                      },
                    ],
                    onFilter: (value, record) => record?.type === value,
                    render: (text, record) => {
                      let colorStyle;
                      switch (record.type) {
                        case "Layaway":
                          colorStyle = { color: "#007BFF" };
                          break;
                        case "Return":
                          colorStyle = { color: "#f0ad4e" };
                          break;
                        case "Receipt":
                          colorStyle = { color: "#28a745" };
                          break;
                        default:
                          colorStyle = {};
                      }

                      return (
                        <div style={{ position: "relative" }}>
                          <span style={colorStyle}>{text}</span>
                          {record.status === "Success" ? (
                            <CheckCircleTwoTone
                              style={{
                                fontSize: "1rem",
                                cursor: "pointer",
                                marginLeft: "1vw",
                                position: "absolute",
                                right: 1,
                                top: "15%",
                              }}
                              twoToneColor="#A4CD38"
                            />
                          ) : (
                            <ExclamationCircleTwoTone
                              style={{
                                fontSize: "1rem",
                                cursor: "pointer",
                                marginLeft: "1vw",
                                position: "absolute",
                                right: 1,
                                top: "15%",
                              }}
                              twoToneColor="red"
                            />
                          )}
                        </div>
                      );
                    },
                  },
                ]}
                style={{
                  width: "100%",
                  overflowY: "auto",
                  border: "none",
                  // fontSize: "1vw",
                  borderRadius: "7px",
                  padding: "0px 7px",
                  // border: "1px solid rgba(146, 144, 152, 0.4)",
                  height: "66vh",
                  background: "#fff",
                }}
                dataSource={visibleOrders}
                pagination={false}
                onRow={(record) => ({
                  onClick: async () => {
                    try {
                      setLoadingDetails(true);
                      setSelectedIsCancelled(isCancelledPreorder(record));
                      const details = await getSalesHistoryData(record.sOrderID);
                      setSelectedOrderDetails(details?.[0] || null);
                    } catch (err) {
                      console.error("Failed to fetch order details", err);
                    } finally {
                      setLoadingDetails(false);
                    }
                  },
                })}
              />
            </Card>
          </Col>

          <Col className="preorder-details-col" span={8} style={{ height: "100%" }}>
            {selectedOrderDetails ? (
              <Card
                style={{ height: "100%", borderRadius: "10px" }}
                styles={{ body: { padding: "16px", display: "flex", flexDirection: "column", height: "100%" } }}
                title={renderOrderDetailsTitle()}
              >
                {renderOrderDetailsBody()}
              </Card>
            ) : (
              <Card
                style={{ height: "100%", borderRadius: "10px" }}
                styles={{
                  body: {
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                    fontSize: "12px",
                    color: "#6b7280",
                    marginTop: "2vh",
                  },
                }}
              >
                Click on any order to view details
              </Card>
            )}
          </Col>
        </Row>

        {/* Mobile only: .preorder-details-col above is hidden via CSS on
            mobile (restaurantStyle.css) instead of stacking the details
            panel below the table — reopens the same title/body content
            (renderOrderDetailsTitle/Body above) in a right-side Drawer so
            tapping a row doesn't push the table out of view. Desktop is
            untouched — this never opens there since isMobile is false. */}
        {isMobile && (
          <Drawer
            title={selectedOrderDetails ? renderOrderDetailsTitle() : "Order Details"}
            placement="right"
            width="62%"
            rootClassName="preorder-details-drawer"
            open={isMobile && !!selectedOrderDetails}
            onClose={() => setSelectedOrderDetails(null)}
          >
            {selectedOrderDetails && renderOrderDetailsBody()}
          </Drawer>
        )}
        <AdvanceOrderCancelModal
          open={showCancelModal}
          order={selectedOrderDetails}
          currency={tillData?.tillAccess?.csBunit?.currencies?.[0]}
          onClose={() => setShowCancelModal(false)}
          onCancelled={() => {
            const cancelledOrderId = selectedOrderDetails?.sOrderID;
            setShowCancelModal(false);
            // List is not re-fetched; patch the row so it moves to the Cancelled tab and
            // the details panel turns view-only (BUG-2485), as a server reload would show.
            setOrderHistoryDetails((list) =>
              (list || []).map((order) => (order.sOrderID === cancelledOrderId ? { ...order, docstatus: "CAN", type: "Cancelled" } : order))
            );
            setSelectedOrderDetails((current) => (current?.sOrderID === cancelledOrderId ? { ...current, docstatus: "CAN" } : current));
            setSelectedIsCancelled(true);
          }}
        />
      </div>
    </Spin>
  );
};

export default RestaurantPreorder;
